import { useSelector, useDispatch } from 'react-redux'
import Hls from 'hls.js'
import PropTypes from 'prop-types'
import React, { useMemo, useCallback } from 'react'

import * as actions from './videoPlayer.actions'
import * as selectors from './videoPlayer.selectors'
import Video from './Video'

/**
 *  Video Player with Http Live Streaming support.
 */
const VideoPlayer = ({ mediaId, videoOptions }) => {
  const dispatch = useDispatch()

  // Redux selectors
  const preloaded = useSelector(selectors.getPreloaded)

  // Action creators (no usado en este componente por ahora)
  // const finishMediaPlayback = useCallback(() => dispatch(actions.finishMediaPlayback()), [dispatch])

  // Memoized calculations
  const { url, isHls } = useMemo(() => {
    const videoUrl = preloaded[mediaId]
    const hlsSupported = videoUrl && videoUrl.match(/\.m3u8(\?.+=.+)*$/i) && Hls.isSupported()

    return {
      url: videoUrl,
      isHls: hlsSupported,
    }
  }, [preloaded, mediaId])

  /**
   *  Render component - renderizado condicional al final
   */
  if (!url) {
    return null
  }

  return <Video url={url} videoOptions={videoOptions} isHls={isHls} />
}

VideoPlayer.propTypes = {
  mediaId: PropTypes.string,
  videoOptions: PropTypes.object,
}

export default VideoPlayer
